var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { PubInputField } from 'components/Shared/PubInputField/PubInputField';
import { InputFieldType } from 'models/Input/InputModels';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Menu from '@mui/material/Menu';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useAuth } from 'services/auth/AuthProvider';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { ProductBuildPageTableRow } from 'components/ProductBuild/ProductBuildPage/ProductBuildPageTableRow/ProductBuildPageTableRow';
import { searchForParentByChildId } from 'services/api/search-kits';
import { useLoaderData, useLocation, useSearchParams } from 'react-router-dom';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { replaceProductNbrPlaceholder, validateRangeInput } from 'utils/product-build-helper';
import { BLANK_OPTION_CODE, REQUEST_TYPE_QUOTE } from 'utils/constants';
import { validate } from 'services/api/product-service';
import { NextFeatureRow } from 'components/ProductBuild/ProductBuildPage/NextFeatureRow/NextFeatureRow';
import Radio from '@mui/material/Radio';
import Divider from '@mui/material/Divider';
import styles from './OptionsTab.module.scss';
export function OptionsTab(_a) {
    var _this = this;
    var _b, _c, _d;
    var buildMode = _a.buildMode, showCustom = _a.showCustom, changedValidationResp = _a.changedValidationResp, updateKitsValue = _a.updateKitsValue, userHasRoyaltyPrivileges = _a.userHasRoyaltyPrivileges;
    var location = useLocation();
    var searchParams = useSearchParams()[0];
    var params = useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        var p = {
            text: (_a = searchParams.get('productNbr')) !== null && _a !== void 0 ? _a : '',
            date: (_b = searchParams.get('date')) !== null && _b !== void 0 ? _b : '',
            time: (_c = searchParams.get('time')) !== null && _c !== void 0 ? _c : '',
            rbv: (_d = searchParams.get('channel')) !== null && _d !== void 0 ? _d : '',
            id: (_e = searchParams.get('pid')) !== null && _e !== void 0 ? _e : '',
            version: (_f = searchParams.get('productVerson')) !== null && _f !== void 0 ? _f : '',
        };
        if (searchParams.has('parsedProductId')) {
            var newDate = new Date(searchParams.get('parsedTimestamp'));
            var date = newDate.getDate().toString().length > 1 ? newDate.getDate() : "0".concat(newDate.getDate());
            var month = (newDate.getMonth() + 1).toString().length > 1 ? newDate.getMonth() + 1 : "0".concat(newDate.getMonth() + 1);
            var year = newDate.getFullYear();
            var splitDate = newDate.toString().split(' ');
            p.date = "".concat(year, "-").concat(month, "-").concat(date);
            // eslint-disable-next-line prefer-destructuring
            p.time = splitDate[4];
            p.rbv = 'Commercial';
        }
        return p;
    }, [searchParams]);
    var nextFeatureRowRef = useRef(null);
    var loaderData = useLoaderData();
    var checkForKitChildren = useCallback(function (validateRsp) { return __awaiter(_this, void 0, void 0, function () {
        var listOfParents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (validateRsp.kitParent)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, searchForParentByChildId(loaderData.validateRsp.body.productId, params.date)];
                case 1:
                    listOfParents = _a.sent();
                    if (listOfParents.length > 0) {
                        updateKitsValue === null || updateKitsValue === void 0 ? void 0 : updateKitsValue(listOfParents);
                    }
                    return [2 /*return*/, listOfParents];
            }
        });
    }); }, [loaderData.validateRsp, updateKitsValue, params]);
    if (loaderData.validateRsp.body.completeProductInd) {
        checkForKitChildren(loaderData.validateRsp.body);
    }
    var _e = useState(
    // eslint-disable-next-line no-nested-ternary
    sessionStorage.getItem('latestValidate')
        ? JSON.parse(sessionStorage.getItem('latestValidate'))
        : ((_b = location.state) === null || _b === void 0 ? void 0 : _b.validate)
            ? location.state.validateRsp
            : (_c = loaderData.validateRsp) === null || _c === void 0 ? void 0 : _c.body), latestValidateResponse = _e[0], setLatestValidateResponse = _e[1];
    var user = useAuth();
    var isGSA = useMemo(function () { return params.rbv === 'GSA'; }, [params]);
    var checkForBaseAndNonBaseProducts = function (validateRsp) {
        var featSelArr = [];
        var featArr = validateRsp.body.features;
        featArr === null || featArr === void 0 ? void 0 : featArr.forEach(function (f) {
            if (f.type !== 'Derived' && f.type !== 'Implied') {
                // feature is base or non base, so should add to featureSelectionArray
                featSelArr.push({ featureId: f.featureId, optionCode: f.optionCode, skuSelection: f.skuSelection });
            }
        });
        return featSelArr;
    };
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var _f = useState(checkForBaseAndNonBaseProducts(loaderData.validateRsp)), featureSelections = _f[0], setFeatureSelections = _f[1];
    var _g = useState(loaderData.restrictionsPresent), isProductRestrictions = _g[0], setIsProductRestrictions = _g[1];
    var _h = useState(loaderData.optionRestrictionsPresent), isOptionRestrictions = _h[0], setIsOptionRestrictions = _h[1];
    var diff;
    var _j = useState('Show None'), selectedOptionalColumn = _j[0], setSelectedOptionalColumn = _j[1];
    var optionalColumns = useMemo(function () { return ['Show None', 'Engineering Model Codes', 'Price Model Codes']; }, []);
    var nextFeature = useMemo(function () { return latestValidateResponse === null || latestValidateResponse === void 0 ? void 0 : latestValidateResponse.nextFeature; }, [latestValidateResponse]);
    var _k = useState(), nsoMetadata = _k[0], setNsoMetadata = _k[1];
    useEffect(function () {
        var _a;
        (_a = nextFeatureRowRef === null || nextFeatureRowRef === void 0 ? void 0 : nextFeatureRowRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, [nextFeature]);
    var mapFeaturesForTable = function (featuresList, singleFeature, isRange, rangeVal, buildFeatures) {
        var _a, _b, _c, _d, _e, _f, _g;
        var autofireVal = false;
        if (buildFeatures) {
            autofireVal = true;
        }
        if (!singleFeature) {
            var myFeatList = featuresList === null || featuresList === void 0 ? void 0 : featuresList.map(function (feature) {
                var _a, _b, _c, _d, _e, _f, _g;
                return ({
                    step: feature.step,
                    type: feature.type,
                    featureName: feature.featureDescription,
                    mfgFeatureModelCode: feature.mfgFeatureModelCode,
                    mfgOptionModelCode: feature.mfgOptionModelCode,
                    prcFeatureModelCode: feature.prcFeatureModelCode,
                    prcOptionModelCode: feature.prcOptionModelCode,
                    subheading: (_a = feature.pbSubHeading) !== null && _a !== void 0 ? _a : '',
                    option: getOptionDescription(feature, isRange !== null && isRange !== void 0 ? isRange : false),
                    options: feature.optionList,
                    isEditable: (feature === null || feature === void 0 ? void 0 : feature.optionList) && ((_b = feature === null || feature === void 0 ? void 0 : feature.optionList) === null || _b === void 0 ? void 0 : _b.length) > 1,
                    restrictionsPresent: (_c = (feature.optionRestrictions && (feature === null || feature === void 0 ? void 0 : feature.optionRestrictions.length) > 0)) !== null && _c !== void 0 ? _c : 0,
                    royaltiesPresent: (_d = (feature.optionRoyalties && (feature === null || feature === void 0 ? void 0 : feature.optionRoyalties.length) > 0)) !== null && _d !== void 0 ? _d : 0,
                    optionRestrictions: (_e = feature.optionRestrictions) !== null && _e !== void 0 ? _e : [],
                    optionRoyalties: (_f = feature.optionRoyalties) !== null && _f !== void 0 ? _f : [],
                    minLeadTime: (_g = feature.minLeadtime) !== null && _g !== void 0 ? _g : '',
                    gsaInd: feature.gsaInd === 'Y' ? 'Y' : '',
                    isFabric: feature.optionType === '3',
                    isNonStandard: feature.nonStandardIndicator,
                    showSelector: false,
                    featureId: feature.featureId,
                    isRange: isRange,
                    rangeVal: isRange ? rangeVal : null,
                    selectedOptionCode: feature.optionCode,
                    skuSelection: feature.skuSelection,
                    range: feature === null || feature === void 0 ? void 0 : feature.range,
                    productId: params.id,
                });
            });
            return myFeatList;
        }
        // is a single item, just map it and return it as an object
        var itemToReturn = {
            step: singleFeature.step,
            type: singleFeature.type,
            featureName: singleFeature.featureDescription,
            mfgFeatureModelCode: singleFeature.mfgFeatureModelCode,
            mfgOptionModelCode: singleFeature.mfgOptionModelCode,
            prcFeatureModelCode: singleFeature.prcFeatureModelCode,
            prcOptionModelCode: singleFeature.prcOptionModelCode,
            subheading: (_a = singleFeature.pbSubHeading) !== null && _a !== void 0 ? _a : '',
            option: getOptionDescription(singleFeature, isRange !== null && isRange !== void 0 ? isRange : false),
            options: singleFeature.optionList,
            autoFire: autofireVal,
            isEditable: ((singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.optionList) && ((_b = singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.optionList) === null || _b === void 0 ? void 0 : _b.length) > 1) || isRange,
            restrictionsPresent: (_d = (singleFeature.optionRestrictions && ((_c = singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.optionRestrictions) === null || _c === void 0 ? void 0 : _c.length) > 0)) !== null && _d !== void 0 ? _d : 0,
            royaltiesPresent: (_f = (singleFeature.optionRoyalties && ((_e = singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.optionRoyalties) === null || _e === void 0 ? void 0 : _e.length) > 0)) !== null && _f !== void 0 ? _f : 0,
            optionRestrictions: singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.optionRestrictions,
            optionRoyalties: singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.optionRoyalties,
            minLeadTime: (_g = singleFeature.minLeadtime) !== null && _g !== void 0 ? _g : 99,
            gsaInd: singleFeature.gsaInd === 'Y' ? 'Y' : '',
            isFabric: singleFeature.optionType === '3',
            isNonStandard: singleFeature.nonStandardIndicator,
            showSelector: false,
            featureId: singleFeature.featureId,
            selectedOptionCode: singleFeature.optionCode,
            isRange: isRange,
            rangeVal: isRange ? rangeVal : null,
            skuSelection: singleFeature.skuSelection,
            range: singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.range,
            productId: params.id,
        };
        return itemToReturn;
    };
    var getOptionDescription = function (singleFeature, isRange) {
        if (isRange) {
            return "Depth Entry (".concat(singleFeature.optionCode, ")");
        }
        if (singleFeature.optionRestrictions && (singleFeature === null || singleFeature === void 0 ? void 0 : singleFeature.optionRestrictions.length) > 0) {
            return "(RESTRICTED) ".concat(singleFeature.optionDescription);
        }
        return singleFeature.optionDescription;
    };
    var getStorageValue = function (key, defaultValue, name) {
        var initial = defaultValue;
        if (typeof window !== 'undefined') {
            var saved = localStorage.getItem(key);
            if (saved !== null) {
                initial =
                    name === 'implied'
                        ? JSON.parse(saved).preferences.showImpliedOptions
                        : JSON.parse(saved).preferences.showDerivedOptions;
            }
        }
        return initial;
    };
    var _l = useState(mapFeaturesForTable(latestValidateResponse === null || latestValidateResponse === void 0 ? void 0 : latestValidateResponse.features)), features = _l[0], setFeatures = _l[1];
    var _m = useState(showCustom !== null && showCustom !== void 0 ? showCustom : getStorageValue('preference', false, 'implied')), isShowImpliedFeatures = _m[0], setIsShowImpliedFeatures = _m[1];
    var _o = useState(getStorageValue('preference', false, 'derived')), isShowDerivedFeatures = _o[0], setIsShowDerivedFeatures = _o[1];
    var _p = useState(null), anchorEl = _p[0], setAnchorEl = _p[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleOptionSelect = function (e, featureId, isRange, rangeVal, buildFeatures, selectedFeatureArray, isAutoSelect) { return __awaiter(_this, void 0, void 0, function () {
        var selectedFeature, newFeatureSelections, mySelOption, newProductNumber, featureArrayCleaned, validateRsp, featuresFromApi, featLength, indexOfFeatureThatNeedsOptions, featureToEdit, featFinal, slicedArray, featuresToUse, myFeatureArray, singleOption, featureSelection;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    selectedFeature = {
                        featureId: featureId,
                        optionCode: e.target.value.optionCode,
                        skuSelection: e.target.value.skuSelection,
                    };
                    newFeatureSelections = [];
                    setFeatureSelections(function (prevVal) {
                        newFeatureSelections = __spreadArray(__spreadArray([], prevVal, true), [selectedFeature], false);
                        return __spreadArray(__spreadArray([], prevVal, true), [selectedFeature], false);
                    });
                    mySelOption = e.target.value;
                    newProductNumber = "".concat(e.target.value.productNbr);
                    if (selectedFeatureArray) {
                        featureArrayCleaned = selectedFeatureArray.map(function (featureSelection) { return (__assign(__assign({}, featureSelection), { optionCode: featureSelection.optionCode === ' ' ? BLANK_OPTION_CODE : featureSelection.optionCode })); });
                    }
                    else {
                        featureArrayCleaned = newFeatureSelections.map(function (featureSelection) { return (__assign(__assign({}, featureSelection), { optionCode: featureSelection.optionCode === ' ' ? BLANK_OPTION_CODE : featureSelection.optionCode })); });
                    }
                    return [4 /*yield*/, validate({
                            productNbr: newProductNumber,
                            requestType: REQUEST_TYPE_QUOTE,
                            processingDate: "".concat(params.date, "T").concat(params.time, ".000Z"),
                            returnNextFeature: true,
                            featureSelections: featureArrayCleaned,
                            productId: params.id,
                        })];
                case 1:
                    validateRsp = _l.sent();
                    if (((_b = (_a = validateRsp === null || validateRsp === void 0 ? void 0 : validateRsp.body) === null || _a === void 0 ? void 0 : _a.restrictions) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        setIsProductRestrictions(true);
                    }
                    else {
                        setIsProductRestrictions(false);
                    }
                    if (validateRsp.body.returnCode === '0') {
                        checkForKitChildren(latestValidateResponse);
                        setSnackbarAlert({
                            message: "Product Build completed with option '".concat(mySelOption.optionCode, "'"),
                            type: 'success',
                        });
                    }
                    if (validateRsp.body.returnCode === '-1' || validateRsp.status !== 200) {
                        setSnackbarAlert({
                            message: (_c = validateRsp.body.returnMessage) !== null && _c !== void 0 ? _c : 'Validate api encountered an error',
                            type: 'error',
                        });
                        return [2 /*return*/];
                    }
                    featuresFromApi = validateRsp.body.features;
                    featLength = featuresFromApi === null || featuresFromApi === void 0 ? void 0 : featuresFromApi.length;
                    indexOfFeatureThatNeedsOptions = featuresFromApi.findIndex(function (feature) { return feature.featureId === featureId; });
                    featureToEdit = featuresFromApi[indexOfFeatureThatNeedsOptions];
                    if (!isAutoSelect) {
                        featureToEdit.optionList = nextFeature === null || nextFeature === void 0 ? void 0 : nextFeature.options;
                    }
                    else {
                        featureToEdit.optionList = [e.target.value];
                    }
                    featFinal = mapFeaturesForTable([], featureToEdit, isRange, rangeVal, buildFeatures);
                    slicedArray = [];
                    if (indexOfFeatureThatNeedsOptions + 1 !== featLength) {
                        slicedArray = featuresFromApi === null || featuresFromApi === void 0 ? void 0 : featuresFromApi.slice(indexOfFeatureThatNeedsOptions + 1, featLength);
                    }
                    featuresToUse = buildFeatures !== null && buildFeatures !== void 0 ? buildFeatures : features;
                    myFeatureArray = __spreadArray(__spreadArray([], featuresToUse, true), [featFinal], false);
                    if (slicedArray.length > 0) {
                        slicedArray.forEach(function (derivedFeature) {
                            myFeatureArray.push(mapFeaturesForTable([], derivedFeature));
                        });
                    }
                    setFeatures(myFeatureArray);
                    checkForOptionRestrictions(myFeatureArray);
                    setLatestValidateResponse(validateRsp.body);
                    sessionStorage.setItem('latestValidate', JSON.stringify(validateRsp.body));
                    if (((_e = (_d = validateRsp.body.nextFeature) === null || _d === void 0 ? void 0 : _d.options) === null || _e === void 0 ? void 0 : _e.length) === 1 &&
                        ((_g = (_f = validateRsp.body.nextFeature) === null || _f === void 0 ? void 0 : _f.options) === null || _g === void 0 ? void 0 : _g[0].range) === null) {
                        singleOption = (_j = (_h = validateRsp.body.nextFeature) === null || _h === void 0 ? void 0 : _h.options) === null || _j === void 0 ? void 0 : _j[0];
                        featureSelection = {
                            featureId: ((_k = validateRsp.body.nextFeature) === null || _k === void 0 ? void 0 : _k.featureId).trim(),
                            optionCode: singleOption.optionCode,
                            skuSelection: singleOption === null || singleOption === void 0 ? void 0 : singleOption.skuSelection,
                        };
                        handleAutoSelect(singleOption, featureSelection, newFeatureSelections, myFeatureArray);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAutoSelect = function (option, featureSelection, newFeatureSelections, myFeatureArray) {
        handleOptionSelect({ target: { value: option } }, featureSelection.featureId, false, undefined, myFeatureArray, __spreadArray(__spreadArray([], newFeatureSelections, true), [featureSelection], false), true);
    };
    var checkForOptionRestrictions = function (arr) {
        arr.every(function (feature) {
            var _a;
            var returnVal = true;
            if (((_a = feature === null || feature === void 0 ? void 0 : feature.options) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                feature.options.every(function (option) {
                    if (feature.selectedOptionCode === option.optionCode) {
                        if (!option.optionRestrictionPresent) {
                            setIsOptionRestrictions(false);
                            returnVal = true;
                            return true;
                        }
                        setIsOptionRestrictions(true);
                        returnVal = false;
                        return false;
                    }
                    return true;
                });
            }
            return returnVal;
        });
    };
    var handleOptionEdit = function (mySelectedOption, featureOfOption, rangeVal, newFeatSelects) {
        featureOfOption.selectedOptionCode = rangeVal !== null && rangeVal !== void 0 ? rangeVal : mySelectedOption.optionCode;
        setFeatures(function (prevVal) {
            var indexOfFeature = prevVal.findIndex(function (feature) { return feature.featureId === featureOfOption.featureId; });
            var slicedArray = prevVal.slice(0, indexOfFeature);
            slicedArray.push(featureOfOption);
            checkForOptionRestrictions(slicedArray);
            return slicedArray;
        });
        var newArray = [];
        if (!newFeatSelects) {
            var index = featureSelections.findIndex(function (item) { return item.featureId === featureOfOption.featureId; });
            var slicedArray = featureSelections.slice(0, index);
            slicedArray.push({ featureId: featureOfOption.featureId, optionCode: mySelectedOption.optionCode, skuSelection: mySelectedOption.skuSelection });
            newArray = slicedArray;
        }
        else {
            newArray = newFeatSelects;
        }
        var featureId = newArray[newArray.length - 1].featureId;
        var uniqueArray = newArray
            .filter(function (obj, index, self) {
            return index === self.findIndex(function (t) { return t.featureId === obj.featureId && t.optionCode === obj.optionCode; });
        })
            .map(function (featureSelection) { return (__assign(__assign({}, featureSelection), { optionCode: featureSelection.optionCode === ' ' ? BLANK_OPTION_CODE : featureSelection.optionCode })); });
        setFeatureSelections(uniqueArray);
        var autoBuildData = {
            productNbr: mySelectedOption.productNbr,
            myFeatureSelections: uniqueArray,
            mySelectedOption: mySelectedOption,
            myVal: 0,
            featureId: featureId,
        };
        fireAutoBuild(autoBuildData);
    };
    var fireAutoBuild = function (_a) {
        var productNbr = _a.productNbr, myFeatureSelections = _a.myFeatureSelections, mySelectedOption = _a.mySelectedOption, myVal = _a.myVal, featureId = _a.featureId;
        return __awaiter(_this, void 0, void 0, function () {
            var newProductNumber, payload, data, featureLength, featureArrayInclDerived, newNext, derivedFeatures, featsToUse_1, indexOfFeatureEdited, length, arr, featSelect, sliceIndex, newFeats, i, optionsFromStorage, editedFeature, mappedFeature, featsToUse;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
            return __generator(this, function (_z) {
                switch (_z.label) {
                    case 0:
                        newProductNumber = latestValidateResponse
                            ? latestValidateResponse.productPrefix +
                                myFeatureSelections.map(function (f) { return f.skuSelection ? f.optionCode : ''; }).join('')
                            : productNbr;
                        payload = {
                            productNbr: newProductNumber,
                            requestType: REQUEST_TYPE_QUOTE,
                            processingDate: "".concat(params.date, "T").concat(params.time, ".000Z"),
                            returnNextFeature: true,
                            featureSelections: myFeatureSelections,
                            productId: params.id,
                        };
                        return [4 /*yield*/, validate(payload)];
                    case 1:
                        data = _z.sent();
                        diff = (_b = data.body.features) === null || _b === void 0 ? void 0 : _b.length;
                        featureLength = (_c = data.body.features) === null || _c === void 0 ? void 0 : _c.length;
                        newNext = {
                            key: (_e = (_d = data.body) === null || _d === void 0 ? void 0 : _d.nextFeature) === null || _e === void 0 ? void 0 : _e.featureId,
                            options: (_g = (_f = data.body) === null || _f === void 0 ? void 0 : _f.nextFeature) === null || _g === void 0 ? void 0 : _g.options,
                        };
                        if (featureLength !== diff + 1) {
                            derivedFeatures = (_h = data.body.features) === null || _h === void 0 ? void 0 : _h.slice(diff + 1, featureLength);
                            if ((derivedFeatures === null || derivedFeatures === void 0 ? void 0 : derivedFeatures.length) > 0) {
                                featsToUse_1 = derivedFeatures;
                            }
                            else {
                                indexOfFeatureEdited = (_j = data.body.features) === null || _j === void 0 ? void 0 : _j.findIndex(function (feature) { return feature.featureId === featureId; });
                                length = (_k = data.body.features) === null || _k === void 0 ? void 0 : _k.length;
                                arr = (_l = data.body.features) === null || _l === void 0 ? void 0 : _l.slice(indexOfFeatureEdited, length);
                                featsToUse_1 = arr;
                            }
                            setFeatures(function (prevVal) {
                                var myDerivedFeatures = mapFeaturesForTable(featsToUse_1);
                                var indexOfFeatureEdited = myDerivedFeatures.findIndex(function (feature) { return feature.featureId === featureId; });
                                var option = myDerivedFeatures[indexOfFeatureEdited];
                                var newArray = __spreadArray([], prevVal, true);
                                newArray.map(function (item) {
                                    var _a, _b, _c;
                                    if (item.featureId === featureId) {
                                        item.optionRestrictions = option === null || option === void 0 ? void 0 : option.optionRestrictions;
                                        item.optionRoyalties = option === null || option === void 0 ? void 0 : option.optionRoyalties;
                                        item.restrictionsPresent =
                                            (_a = ((option === null || option === void 0 ? void 0 : option.optionRestrictions) && (option === null || option === void 0 ? void 0 : option.optionRestrictions.length) > 0)) !== null && _a !== void 0 ? _a : false;
                                        item.royaltiesPresent =
                                            (_b = ((option === null || option === void 0 ? void 0 : option.optionRoyalties) && (option === null || option === void 0 ? void 0 : option.optionRoyalties.length) > 0)) !== null && _b !== void 0 ? _b : false;
                                        item.minLeadTime = (_c = option === null || option === void 0 ? void 0 : option.minLeadTime) !== null && _c !== void 0 ? _c : 0;
                                    }
                                    return item;
                                });
                                myDerivedFeatures.forEach(function (feature) {
                                    if (feature.type === 'Derived') {
                                        newArray.push(feature);
                                    }
                                });
                                featureArrayInclDerived = newArray;
                                checkForOptionRestrictions(newArray);
                                return newArray;
                            });
                        }
                        if (((_o = (_m = data.body) === null || _m === void 0 ? void 0 : _m.restrictions) === null || _o === void 0 ? void 0 : _o.length) > 0) {
                            setIsProductRestrictions(true);
                        }
                        else {
                            setIsProductRestrictions(false);
                        }
                        setLatestValidateResponse(data.body);
                        sessionStorage.setItem('latestValidate', JSON.stringify(data.body));
                        if (data.body.returnCode === '0') {
                            checkForKitChildren(latestValidateResponse);
                            setSnackbarAlert({
                                message: "Product Build completed with option '".concat(mySelectedOption.optionCode, "'"),
                                type: 'success',
                            });
                        }
                        if (data.body.returnCode === '-1' || data.status !== 200) {
                            setSnackbarAlert({
                                message: (_p = data.body.returnMessage) !== null && _p !== void 0 ? _p : 'Error encountered',
                                type: 'error',
                            });
                            return [2 /*return*/];
                        }
                        if (((_q = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _q === void 0 ? void 0 : _q.length) === 1 && ((_r = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _r === void 0 ? void 0 : _r[0].range) === null) {
                            featSelect = {
                                featureId: newNext.key,
                                optionCode: (_s = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _s === void 0 ? void 0 : _s[0].optionCode,
                                skuSelection: (_t = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _t === void 0 ? void 0 : _t[0].skuSelection,
                            };
                            sliceIndex = features.findIndex(function (feature) { return feature.featureId === featureId; });
                            newFeats = features.slice(0, sliceIndex);
                            i = (_v = (_u = data.body) === null || _u === void 0 ? void 0 : _u.features) === null || _v === void 0 ? void 0 : _v.findIndex(function (feature) { return feature.featureId === featureId; });
                            optionsFromStorage = features.find(function (feature) { return feature.featureId === featureId; });
                            editedFeature = (_x = (_w = data === null || data === void 0 ? void 0 : data.body) === null || _w === void 0 ? void 0 : _w.features) === null || _x === void 0 ? void 0 : _x[i];
                            editedFeature.optionList = optionsFromStorage === null || optionsFromStorage === void 0 ? void 0 : optionsFromStorage.options;
                            mappedFeature = mapFeaturesForTable([], editedFeature);
                            featsToUse = __spreadArray(__spreadArray([], newFeats, true), [mappedFeature], false);
                            if (featureArrayInclDerived) {
                                featsToUse = featureArrayInclDerived;
                            }
                            handleAutoSelect((_y = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _y === void 0 ? void 0 : _y[0], featSelect, myFeatureSelections, featsToUse);
                        }
                        else {
                            features === null || features === void 0 ? void 0 : features.forEach(function (storedFeature) {
                                var _a;
                                // these can probably be turned in everys to loop less
                                if (newNext.key === storedFeature.featureId) {
                                    (_a = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _a === void 0 ? void 0 : _a.forEach(function (option) {
                                        var _a, _b, _c;
                                        var isRangeOption = (option === null || option === void 0 ? void 0 : option.range) !== undefined && (option === null || option === void 0 ? void 0 : option.range) !== null;
                                        if (isRangeOption || ((_a = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _a === void 0 ? void 0 : _a.length) > 1) {
                                            if (option.optionCode === storedFeature.selectedOptionCode ||
                                                (isRangeOption &&
                                                    validateRangeInput(option.range, (_b = storedFeature === null || storedFeature === void 0 ? void 0 : storedFeature.selectedOptionCode) !== null && _b !== void 0 ? _b : ''))) {
                                                myFeatureSelections.push({
                                                    featureId: storedFeature.featureId,
                                                    optionCode: option.optionCode,
                                                    skuSelection: option.skuSelection,
                                                });
                                                var rangeOptionProductNbr = isRangeOption &&
                                                    replaceProductNbrPlaceholder(option.productNbr, '{}', storedFeature.selectedOptionCode);
                                                if (myVal > 0) {
                                                    setSnackbarAlert({
                                                        message: "Building with option '".concat(mySelectedOption.optionCode, "' in storage"),
                                                        type: 'success',
                                                    });
                                                }
                                                diff = (_c = data.body.features) === null || _c === void 0 ? void 0 : _c.length;
                                                setFeatures(function (prevVal) {
                                                    checkForOptionRestrictions(__spreadArray(__spreadArray([], prevVal, true), [storedFeature], false));
                                                    storedFeature.options = newNext === null || newNext === void 0 ? void 0 : newNext.options;
                                                    return __spreadArray(__spreadArray([], prevVal, true), [storedFeature], false);
                                                });
                                                var newPassedProductNumber = isRangeOption && rangeOptionProductNbr ? rangeOptionProductNbr : option.productNbr;
                                                var newOption = isRangeOption && rangeOptionProductNbr
                                                    ? __assign(__assign({}, option), { productNbr: rangeOptionProductNbr, optionCode: storedFeature.selectedOptionCode }) : option;
                                                fireAutoBuild({
                                                    myFeatureSelections: myFeatureSelections,
                                                    productNbr: newPassedProductNumber,
                                                    mySelectedOption: newOption,
                                                    myVal: myVal + 1,
                                                    featureId: storedFeature.featureId,
                                                });
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleOptionalColumnSelect = function (col) {
        if (selectedOptionalColumn !== col) {
            setSelectedOptionalColumn(col);
        }
        else {
            setSelectedOptionalColumn('');
        }
        setAnchorEl(null);
    };
    var handleShowToggleFeature = function (event, name) {
        var _a;
        var preferenceData = {
            userId: (_a = user.user) === null || _a === void 0 ? void 0 : _a.userId,
            preferences: {
                showImpliedOptions: isShowImpliedFeatures,
                showDerivedOptions: isShowDerivedFeatures,
            },
        };
        if (name === 'implied') {
            setIsShowImpliedFeatures(event.target.checked);
            preferenceData.preferences.showImpliedOptions = event.target.checked;
        }
        else {
            setIsShowDerivedFeatures(event.target.checked);
            preferenceData.preferences.showDerivedOptions = event.target.checked;
        }
        localStorage.setItem('preference', JSON.stringify(preferenceData));
    };
    useEffect(function () {
        changedValidationResp(latestValidateResponse, isProductRestrictions, isOptionRestrictions !== null && isOptionRestrictions !== void 0 ? isOptionRestrictions : false);
    }, [changedValidationResp, isOptionRestrictions, isProductRestrictions, latestValidateResponse]);
    var captureNsoMetadata = function (e) {
        if (e) {
            setNsoMetadata(e);
            sessionStorage.setItem('nsoMetadata', JSON.stringify(e));
        }
    };
    return (_jsxs(Box, { children: [_jsxs(Box, __assign({ className: styles.buildFiltersContainer }, { children: [_jsx(Typography, __assign({ className: styles.title }, { children: "Product Options" })), _jsxs(Box, __assign({ className: styles.switchContainer }, { children: [_jsx(PubInputField, { fieldType: InputFieldType.SWITCH, fieldValueUpdateHandler: function (e) { return handleShowToggleFeature(e, 'implied'); }, switchLabel: "".concat(isShowImpliedFeatures ? 'Hide' : 'Show', " Implied Options"), switchWidth: 250, defaultChecked: isShowImpliedFeatures }), _jsx(Box, __assign({ className: styles.rightSwitch }, { children: _jsx(PubInputField, { fieldType: InputFieldType.SWITCH, fieldValueUpdateHandler: function (e) { return handleShowToggleFeature(e, 'derived'); }, switchLabel: "".concat(isShowDerivedFeatures ? 'Hide' : 'Show', " Derived Options"), switchWidth: 250, defaultChecked: isShowDerivedFeatures }) }))] })), _jsxs(FormControl, __assign({ sx: { m: 1, width: 250 } }, { children: [_jsx(Button, __assign({ id: "demo-customized-button", onClick: handleClick, startIcon: _jsx(FormatListBulletedIcon, { sx: { paddingRight: 1 } }), className: styles.btnOptional }, { children: "Optional Columns" })), _jsx(Menu, __assign({ anchorEl: anchorEl, open: open, onClose: function () { return setAnchorEl(null); } }, { children: optionalColumns === null || optionalColumns === void 0 ? void 0 : optionalColumns.map(function (col, index) { return (_jsxs(Box, { children: [_jsxs(MenuItem, __assign({ value: col, onClick: function () { return handleOptionalColumnSelect(col); } }, { children: [_jsx(Radio, { checked: col === selectedOptionalColumn, onChange: function () { return handleOptionalColumnSelect(col); }, value: col, name: "optionalColumnRadio" }), _jsx(ListItemText, { primary: col })] }), col), index < optionalColumns.length - 1 && _jsx(Divider, {})] }, col)); }) }))] }))] })), _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Step" })), _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Type" })), _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Feature" })), selectedOptionalColumn !== 'Show None' && (_jsx(TableCell, __assign({ sx: {
                                        width: '5%',
                                    }, className: styles.tableHeaderCell }, { children: "Feature Model Code" }))), _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Subheading" })), _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Option" })), selectedOptionalColumn !== 'Show None' && (_jsx(TableCell, __assign({ sx: {
                                        width: '5%',
                                    }, className: styles.tableHeaderCell }, { children: "Option Model Code" }))), _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Restr." })), userHasRoyaltyPrivileges && _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Royalty" })), _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "Min. Lead Time" })), _jsx(TableCell, __assign({ className: styles.tableHeaderCell }, { children: "GSA" }))] }) }), _jsxs(TableBody, { children: [(_d = features === null || features === void 0 ? void 0 : features.filter(function (feature) {
                                return (isShowDerivedFeatures && feature.type === 'Derived') ||
                                    (isShowImpliedFeatures && feature.type === 'Implied') ||
                                    (feature.type !== 'Derived' && feature.type !== 'Implied');
                            })) === null || _d === void 0 ? void 0 : _d.map(function (feature, myInd, array) {
                                var _a;
                                var key = "".concat(feature.featureId, "_").concat(myInd);
                                return (_jsx(ProductBuildPageTableRow, { feature: feature, featureArray: array.slice(0, myInd + 1), index: myInd, handleOptionEditInParent: handleOptionEdit, optionalColumn: selectedOptionalColumn, isGSA: isGSA, latestValidateResponse: latestValidateResponse, timestamp: "".concat(params.date, "T").concat(params.time, ".000Z"), prefix: (_a = latestValidateResponse.productPrefix) !== null && _a !== void 0 ? _a : '', buildMode: buildMode, userHasRoyaltyPrivileges: userHasRoyaltyPrivileges, nsoMetadata: nsoMetadata && JSON.parse(sessionStorage.getItem('nsoMetadata')), showOptionalColumns: selectedOptionalColumn }, key));
                            }), nextFeature && (_jsx(NextFeatureRow, { nextFeatureRef: nextFeatureRowRef, nextFeature: nextFeature, handleOptionSelectInParent: function (e, featureId, isRange, rangeVal) { return handleOptionSelect(e, featureId, isRange, rangeVal); }, hideOptionalColumns: selectedOptionalColumn === 'Show None', isGSA: isGSA, userHasRoyaltyPrivileges: userHasRoyaltyPrivileges, latestValidateResponse: latestValidateResponse, effectiveDate: "".concat(params.date, "T").concat(params.time, ".000Z"), sendNsoMetadataToParent: function (e) { return captureNsoMetadata(e); }, showOptionalColumns: selectedOptionalColumn }))] })] })] }));
}
